/**
 * Ortak Tablo Stilleri - Ön Muhasebe Modülü
 * 
 * Referans: Inventory (Stok) sayfasındaki tablo tasarımı baz alınmıştır.
 * 
 * Kullanım:
 *   import { TABLE_STYLES } from '../shared/tableStyles';
 *   
 *   <Paper elevation={TABLE_STYLES.paper.elevation} sx={TABLE_STYLES.paper.sx}>
 *   <Table size="small" stickyHeader>
 *   <TableCell sx={TABLE_STYLES.headerCell}> ...
 *   <TableRow sx={TABLE_STYLES.dataRow}> ...
 *   <TableCell sx={TABLE_STYLES.dataCell}> ...
 *   <TablePagination sx={TABLE_STYLES.pagination} .../>
 */

import type { SxProps, Theme } from '@mui/material';

// ─── Paper Wrapper ──────────────────────────────────────────────
export const TABLE_PAPER_ELEVATION = 3;

export const TABLE_PAPER_SX: SxProps<Theme> = {
  borderRadius: 2,
  overflow: 'hidden',
};

// ─── Header Hücre Stili ─────────────────────────────────────────
export const TABLE_HEADER_CELL_SX: SxProps<Theme> = {
  color: 'white',
  fontWeight: 'bold',
  fontSize: '0.875rem',
  bgcolor: 'primary.main',
  whiteSpace: 'nowrap',
};

// ─── Veri Satır Stili ───────────────────────────────────────────
export const TABLE_DATA_ROW_SX: SxProps<Theme> = {
  height: '40px',
  '& td': {
    py: 0.25,
    px: 1,
  },
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  cursor: 'pointer',
};

// ─── Veri Hücre Stili ───────────────────────────────────────────
export const TABLE_DATA_CELL_SX: SxProps<Theme> = {
  fontSize: '0.75rem',
};

// ─── Sayfalama Stili ────────────────────────────────────────────
export const TABLE_PAGINATION_SX: SxProps<Theme> = {
  '& .MuiTablePagination-toolbar': {
    minHeight: '40px',
    height: '40px',
    padding: '0 8px',
  },
  '& .MuiTablePagination-selectLabel': {
    margin: 0,
  },
  '& .MuiTablePagination-displayedRows': {
    margin: 0,
  },
};

// ─── Varsayılan Sayfalama Seçenekleri ───────────────────────────
export const TABLE_ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

// ─── Hepsi Bir Arada (Kolay Erişim) ────────────────────────────
export const TABLE_STYLES = {
  paper: {
    elevation: TABLE_PAPER_ELEVATION,
    sx: TABLE_PAPER_SX,
  },
  headerCell: TABLE_HEADER_CELL_SX,
  dataRow: TABLE_DATA_ROW_SX,
  dataCell: TABLE_DATA_CELL_SX,
  pagination: TABLE_PAGINATION_SX,
  rowsPerPageOptions: TABLE_ROWS_PER_PAGE_OPTIONS,
} as const;
